import { DateTime } from 'luxon';
import {
  IEpisodeMonthRecurrence,
  MonthRecurrenceType
} from 'src/app/core/services/extended-program-guide.service';
import findMonthlyRecurrenceWeekDay from './findMonthlyRecurrenceWeekDay';

/**
 * Advances the start date of a month recurrence to the next valid date according to the given monthly recurrence.
 * @param startDate Start date
 * @param recurrence Month recurrence data
 * @returns New start date or error message
 */
export default function advanceMonthRecurrence(
  startDate: DateTime,
  recurrence: IEpisodeMonthRecurrence
) {
  const { recurrence: monthlyRecurrenceInfo } = recurrence;
  switch (monthlyRecurrenceInfo.type) {
    case MonthRecurrenceType.Day:
      startDate = startDate.set({
        day: monthlyRecurrenceInfo.day
      });
      break;
    case MonthRecurrenceType.WeekDay:
      startDate = findMonthlyRecurrenceWeekDay(
        startDate,
        monthlyRecurrenceInfo.week_day,
        monthlyRecurrenceInfo.order
      );
      break;
  }
  return startDate;
}
